import React, { Component } from "react";
import TextField from "@mui/material/TextField";
import DataStore from "./../../../stores/DataStore";
/**
 * @class
 * Zur Anzeige von TextFields
 * @name TextFieldAttribute
 * @implements {Attribute}
 */
class TextFieldAttribute extends Component {
  constructor(params) {
    super(params);
  }

  onChange(evt) {
    const { attribute: { onChange, value = "" } = {} } = this.props;
    onChange(evt.target.value);
  }

  getValue() {
    return DataStore.attributeValues[this.id].value;
  }

  getValueString() {
    const { value = "" } = DataStore.attributeValues[this.id];
    return value.toString();
  }

  getSummaryDisplay() {
    return <div>{this.getValueString()}</div>;
  }

  render() {
    const {
      attribute: {
        id = "",
        name = "",
        attributeOption: { Field = TextField, InputProps = {} },
        attributeModul,
      } = {},
    } = this.props;
    attributeModul.holdedAttribute = this;
    this.id = id;
    return (
      <Field
        disabled={DataStore.attributeValues[this.id].readOnly}
        key={id}
        id={id}
        name={name}
        InputLabelProps={{ shrink: true }}
        style={{
          flexGrow: 1,
          marginRight: "5px",
        }}
        label={name}
        onChange={(evt) => this.onChange(evt)}
        value={DataStore.attributeValues[this.id].value}
        {...InputProps}
      />
    );
  }
}

export default TextFieldAttribute;
